(ns frontend.view.components.form.view
  (:require
   [frontend.view.components.form.components.form-attachments :as form-attachments]
   [frontend.view.components.form.components.form-company-name :as form-company-name]
   [frontend.view.components.form.components.form-currency :as form-currency]
   [frontend.view.components.form.components.form-financials :as form-financials]
   [frontend.view.components.form.components.form-integer :as form-integer]
   [frontend.view.components.form.components.form-multi-select :as form-multi-select]
   [frontend.view.components.form.components.form-numeric :as form-numeric]
   [frontend.view.components.form.components.form-ratings :as form-ratings]
   [frontend.view.components.form.components.form-select :as form-select]
   [frontend.view.components.form.components.form-switch :as form-switch]
   [frontend.view.components.form.components.form-tesi-financials :as form-tesi-financials]
   [frontend.view.components.form.components.form-text :as form-text]
   [frontend.view.components.form.components.form-textarea :as form-textarea]
   [frontend.view.components.form.components.form-url :as form-url]
   [reagent.core :as r]))

(defn generate-year-options
  []
  (->> (range 1900 2030)
       (map (fn [year]
              {:key   (str year)
               :label (str year)}))))

(defn view
  [& view-args]
  (let [edit? (r/atom false)
        set-edit! (fn [v]
                    (reset! edit? v))]
    (fn [{:keys [options type field field-description
                 on-save! cancel-edit!]
          :as   view-args}]
      (let [on-submit! (fn self
                         ([e]
                          (.preventDefault e)
                          (self))
                         ([]
                          (set-edit! false)
                          (on-save!)))
            on-submit-person! (fn []
                                (on-save!))
            on-cancel! (fn [e]
                         (set-edit! false)
                         (when cancel-edit!
                           (cancel-edit!))
                         (when e
                           (.preventDefault e)
                           (.stopPropagation e)))
            on-key-down! (fn [e]
                           (let [key (.-keyCode e)]
                             (when (= key 27)               ;; esc cancels inline editing
                               (on-cancel! e))))
            child-args (merge view-args
                              {:edit?              edit?
                               :info               field-description
                               :set-edit!          set-edit!
                               :on-submit!         on-submit!
                               :on-cancel!         on-cancel!
                               :on-key-down!       on-key-down!
                               :cached-options     (:cached-options field)
                               :multi-select       (:multi-select field)
                               :allow-empty-input? (:allow-empty-input? field)
                               :allow-duplicates   (:allow-duplicates field)
                               :custom-ordering?   (:custom-ordering? field)
                               :options            (or (if (:options-kw field)
                                                         (get options (:options-kw field))
                                                         (:options field))
                                                       (->> field
                                                            :attribute
                                                            (get options)))})]
        (cond
          (= type "textarea")
          [form-textarea/view child-args]
          ;; Special case just used for company-name
          (= type "company-name")
          [form-company-name/view child-args]
          (= type "numeric")
          [form-numeric/view child-args]
          (= type "percentage")
          [form-integer/view (merge child-args {:postfix "%"})]
          (= type "integer")
          [form-integer/view child-args]
          (= type "currency--sym")
          [form-currency/view child-args]
          (= type "date-year")
          [form-select/view (merge child-args {:options (generate-year-options)})]
          (= type "select")
          [form-select/view child-args]
          (= type "multi-select")
          [form-multi-select/view child-args]
          (= type "url")
          [form-url/view child-args]
          (= type "switch")
          [form-switch/view child-args]
          (= type "ratings-modal")
          [form-ratings/ratings-block child-args]
          (= type "attachments")
          [form-attachments/view child-args]
          (= type "tesi-financials")
          [form-tesi-financials/view child-args]
          (= type "financials")
          [form-financials/view child-args]
          (= type "email") [form-text/view
                            (merge child-args
                                   {:edit? @edit?})]
          :else
          [form-text/view
           (merge child-args
                  {:edit? @edit?})])))))
